var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendar2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Iconly/Light/Calendar") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly/Light/Calendar",
    stroke: "#000000",
    strokeWidth: 1.5,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calendar",
    transform: "translate(3.000000, 2.000000)",
    stroke: "#000000",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0.0926400664,
    y1: 7.40425532,
    x2: 17.9165888,
    y2: 7.40425532,
    id: "Line_200"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.4420736,
    y1: 11.3096927,
    x2: 13.4513376,
    y2: 11.3096927,
    id: "Line_201"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.00461445,
    y1: 11.3096927,
    x2: 9.01387846,
    y2: 11.3096927,
    id: "Line_202"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.55789127,
    y1: 11.3096927,
    x2: 4.56715527,
    y2: 11.3096927,
    id: "Line_203"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.4420736,
    y1: 15.1962175,
    x2: 13.4513376,
    y2: 15.1962175,
    id: "Line_204"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.00461445,
    y1: 15.1962175,
    x2: 9.01387846,
    y2: 15.1962175,
    id: "Line_205"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.55789127,
    y1: 15.1962175,
    x2: 4.56715527,
    y2: 15.1962175,
    id: "Line_206"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.0437213,
    y1: -2.26485497e-14,
    x2: 13.0437213,
    y2: 3.29078014,
    id: "Line_207"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.96550756,
    y1: -2.26485497e-14,
    x2: 4.96550756,
    y2: 3.29078014,
    id: "Line_208"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2382655,1.57919622 L4.77096342,1.57919622 C1.83427331,1.57919622 0,3.21513002 0,6.22222222 L0,15.2718676 C0,18.3262411 1.83427331,20 4.77096342,20 L13.2290015,20 C16.1749556,20 18,18.3546099 18,15.3475177 L18,6.22222222 C18.0092289,3.21513002 16.1842196,1.57919622 13.2382655,1.57919622 Z",
    id: "Path"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar2);
export default __webpack_public_path__ + "static/media/Calendar_2.3494831b6fdf2a7be0643e13f301a468.svg";
export { ForwardRef as ReactComponent };